import ComingSoon from "../components/ComingSoon";
import NewsletterForm from "../components/NewsletterForm";

const ITEMS = [
  { kind: "Roundtable", title: "Operationalising the EU AI Act after the Digital Omnibus", body: "A closed-door discussion on the practical compliance posture under the revised timeline." },
  { kind: "Webinar", title: "Bias audits — from report to product change", body: "A working session translating audit results into concrete product changes." },
  { kind: "Workshop", title: "Ethical Impact Assessment in practice", body: "A facilitated walkthrough of the EIA template using a real procurement scenario." },
  { kind: "Presidency", title: "Ireland's EU Council Presidency briefings", body: "A series of practitioner briefings during Ireland's July–December 2026 presidency window." },
];

export default function Community() {
  return (
    <>
      <ComingSoon
        kicker="Community & Events"
        title="A working community for people responsible for AI in the real world."
        lede="Closed-door roundtables, working webinars, and open workshops are being scheduled around the EU AI Act timeline and Ireland's 2026 Council Presidency. Subscribe below to receive invitations."
        items={ITEMS}
      />
      <section className="border-t border-[var(--eai-border)] bg-[var(--eai-bg-2)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="overline">The weekly briefing</p>
            <h2 className="mt-4 font-display text-3xl lg:text-5xl font-semibold tracking-tight leading-[1.05]">Get invitations as they open.</h2>
            <p className="mt-6 text-[var(--eai-ink-2)] leading-relaxed max-w-md">
              Subscribers receive event invitations and the weekly briefing on AI ethics, policy, and Ireland-specific developments.
            </p>
          </div>
          <div className="lg:col-span-7">
            <NewsletterForm />
          </div>
        </div>
      </section>
    </>
  );
}
